module.exports = __webpack_public_path__ + "static/media/violet.3ab635a2.png";